import React from 'react'
import { useState, useEffect, useContext, useRef, useReducer } from "react";
import { RxDotsVertical } from "react-icons/rx";
import ThreeDots from '../icons/ThreeDots';

function EditMenu({ menuData, wrapperData, himself }) {


  const [menuDropdown, setMenuDropdown] = menuData;

  const handleMenuSelect = (i) => {
    menuDropdown[i].onClick()
    setOpenWrapperMenu(false)
  }
  const wrapperRefMenu = React.useRef(null);
  const [openWrapperMenu, setOpenWrapperMenu] = wrapperData;
  useOutsideAlerter(wrapperRefMenu, setOpenWrapperMenu);

  function useOutsideAlerter(ref, setX) {
    React.useEffect(() => {
      /**
       * Alert if clicked on outside of element
       */
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setX(false);
        }
      }
      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref, setX]);
  }


  return (
    <div
      onMouseEnter={() => setOpenWrapperMenu(true)}
      onMouseLeave={() => setOpenWrapperMenu(false)}
      ref={wrapperRefMenu} className="relative flex w-fit">
      <div
        onClick={() => setOpenWrapperMenu((prev) => !prev)}
        className="flex items-center">
        <button className="inline-flex self-center items-center py-1 text-sm font-medium text-center text-gray-500 hover:text-gray-800 rounded-lg dark:bg-gray-900 dark:hover:bg-gray-800 dark:focus:ring-gray-600" type="button">
          <ThreeDots className="w-1 h-2.5 md:h-3" />
        </button>
      </div>

      {/* ---------------MENU DROPDOWN ------------ */}
      <div style={{ "position": "revert-layer", "zIndex": 1 }}
        className={`py-2 -top-[16px] ${himself ? "right-[20px]" : "left-[20px]"} min-w-[125px] absolute z-10 ${himself ? 'origin-[136px_23px]' : 'origin-[-10px_23px]'} transition-all duration-200 ease-in-out ${openWrapperMenu ? "scale-100" : "scale-0"}`}
      >
        <div
          className={`flex flex-col p-1.5 ${himself ? "rounded-l-xl" : "rounded-r-xl"} rounded-b-xl border-gray-600 border bg-white shadow-md dark:!bg-navy-800 dark:text-white dark:shadow-none`}>

          {menuDropdown.map((item, ind) => (

            <button
              onClick={() => (handleMenuSelect(ind))} className="flex w-full items-center hover:font-bold">

              <div className="flex h-full w-full flex-col rounded-lg pl-1 text-sm md:text-base">
                <label className="flex items-center px-1 group cursor-pointer uppercase text-sm text-gray-900 hover:text-gray-800 dark:text-gray-300">

                  <div className="text-gray-400 group-hover:text-headPrimary mr-2 h-3.5 w-3.5">
                    {item.icon}
                  </div>
                  <nobr >
                    {item.name}
                  </nobr>
                </label>
                {ind !== menuDropdown.length - 2 && <hr className="my-1.5" />}
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  )
}

export default EditMenu